import React, { useEffect, useContext } from 'react'
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Routes/AuthProvider"
//import { GetPaymentStatus } from "../Services/API"
import { FlightBooking } from "../Services/API";

const HdfcPaymentResponse = () => {
    // debugger;
    const navigate = useNavigate();
    const { userName } = useContext(AuthContext);
    const query = new URLSearchParams(useLocation().search);
    const orderId = query.get("order_id");
    const key = query.get("key");
    const status = query.get("status");

useEffect(() => {
    const CallFlightBooking = async () => {
        try {
            const response = await FlightBooking({
                clientCode: "BerryJourneys",
                userID: userName,
                key: key,
                referenceNo: orderId,
            });

            console.log("FlightBooking API Response:", response);

            if (response && response.error === null &&(response.status === "Confirmed" || response.status === "Failure")) {
                navigate(`/thankyou?ReferenceNo=${orderId}`);

            } else {
                alert(response.error.description);
                navigate(`/thankyou?ReferenceNo=${orderId}`);
                console.error("Flight booking failed:", response);
            }

        } catch (error) {
            console.error("Error calling FlightBooking API", error);
        }
    };

    if (orderId && status === "CHARGED") {
        CallFlightBooking();
    }
    else {
        navigate(`/thankyou?ReferenceNo=${orderId}`);
    }

}, [orderId, status]);

    return (
        <>
            <p className="text-center load"><span className="loader"></span></p>
        </>
    )
}

export default HdfcPaymentResponse
